<template>
    <div>
        <a-card 
        size="small" 
        title="基本信息" 
        :headStyle='{
            background : "#f3f3f3"
        }'
        >
            <template v-slot:extra>
                <a-button @click='backPage'>返回</a-button>


            </template>
            <a-row class='title_row'>
                <a-col :span="12">
                    <span class='clb'>订单号：</span>
                    {{detail.orderCode}}
                    <a-button type="primary" style='margin-left:10px' @click='associated'>
                        关联单
                       
                    </a-button>
                </a-col>
                <a-col :span="12" style='color:red'>
                        <span class='clb'>状态：</span>
                        {{changeState(detail)}}
                
                </a-col>
            </a-row>

            <a-row style='margin-top:20px'>
                <a-col :span="6">
                    <span class='clb'>下单时间：</span>
                    {{detail.createTime}}
                    
                </a-col>
            


                <a-col :span="6">
                    <span class='clb'>支付状态：</span>
                    {{detail.payStateValue}}
                    

                </a-col>
                <!-- <a-col :span="6">
                    <span class='clb'>出票供应：</span>
                    暂无
                
                </a-col>
                <a-col :span="6">
                    <span class='clb'>供应单号：</span>
                    暂无
                
                </a-col> -->
            </a-row>
            <a-row style='margin-top:20px'>
                <a-col :span="6">
                    <span class='clb'>备注：</span>
                    {{detail.remark}}
                    
                </a-col>
               
            </a-row>

        </a-card>

        <a-card 
        size="small" 
        title="订票信息" 
        style='margin-top:20px'
        :headStyle='{
            background : "#f3f3f3"
        }'
        >
            <a-row>
                <a-col :span="12">
                    <span class='clb'>联系人：</span>
                    {{detail.contact}}
               
                </a-col>
                <a-col :span="12">
                    <span class='clb'>电话：</span>
                     {{detail.mobile}}
                        
                
                </a-col>
            </a-row>
            <a-row style='margin-top:20px'>
                <a-col :span="12">
                    <span class='clb'>总价：</span>
                    <span>{{detail.totalAmount}}（ 票款 ） + {{detail.serviceAmount?detail.serviceAmount:'0'}}（ 服务费 ） =  <span style='color:red'>¥{{detail.payAmount?detail.payAmount:detail.totalAmount+detail.serviceAmount}}（ 应付 ）</span></span>

                </a-col>

            </a-row>


        </a-card>

        <a-card 
        size="small" 
        title="车票详情"
        style='margin-top:20px'
        :headStyle='{
            background : "#f3f3f3"
        }'
        >
            <a-row>
                <a-col :span="12" class='ticket'>
                    <div>
                        {{detail.fromStation}}
                        <div class='time_div'>{{detail.fromTimeFormat}}</div>
                    </div>
                    <div class='line_content'>
                        <span>耗时{{detail.takeTimeFormat}}</span>
                        <span class='line'></span>
                    </div>
                    <div>
                        {{detail.toStation}}（<span style='color:red'>{{detail.trainNo}}</span>）
                        <div class='time_div'>{{detail.toTimeFormat}}</div>
                    </div>
                </a-col>

            </a-row>

            <a-table :columns="columns" bordered 
                :data-source="detail.purchaseTickets" 
                :pagination='false' 
                
                :row-key="r => r.id"
                :loading='loading'
                style='margin-top:20px'
                >
                <template v-slot:type="{ text,record }">
                    {{record.passengerTypeValue}}
                </template>

                <template v-slot:lastCoach="{ text,record }">
                    {{record.lastCoach}}/{{record.lastSeat}}
                </template>


            </a-table>

        </a-card>

<!--      <a-card-->
<!--          size="small"-->
<!--          title="用户选座信息"-->
<!--          style='margin-top:20px'-->
<!--          :headStyle='{-->
<!--                background : "#f3f3f3"-->
<!--            }'-->
<!--          class='logContent'>-->
<!--        <a-table-->
<!--            :columns="choosesSeatColumn"-->
<!--            :row-key="(r) => r.id"-->
<!--            bordered-->
<!--            :data-source="chooseSeats"-->
<!--            :pagination="false"-->
<!--            :loading="loading"-->
<!--        >-->
<!--          <template v-slot:chooseSeats="{ text, record }">-->
<!--            {{ record.chooseSeats === null || record.chooseSeats === '' ? "无" : record.chooseSeats }}-->
<!--          </template>-->

<!--          <template v-slot:acceptNoSeat="{ text, record }">-->
<!--            {{ record.acceptNoSeat === 0 || record.acceptNoSeat === null? "否" : "是" }}-->
<!--          </template>-->

<!--          <template v-slot:chooseOther="{ text, record }">-->
<!--            {{ record.chooseOther === 0 || record.chooseOther === null? "否" : "是" }}-->
<!--          </template>-->
<!--          <template v-slot:acceptNoTotal="{ text, record }">-->
<!--            {{ record.acceptNoTotal === 0 || record.acceptNoTotal === null ? "否" : "是" }}-->
<!--          </template>-->
<!--        </a-table>-->

<!--      </a-card>-->


        <df-orderLog :list='operationLogList'></df-orderLog>


        <a-modal v-model:visible="modalVisible" title="关联订单" :footer="null">
            <a-list
                item-layout="horizontal"
                :data-source="associateddata"
                class='a_list'
            >
                <template v-slot:renderItem="{ item, index }">
                    <a-list-item>
                        <div class='flex-row'>   
                            <div>{{associateValue[item.orderType]}}：<span style='color:#1890ff;cursor:pointer' @click='toRefoundDetail(item)'>{{item.orderCode}}</span></div>
                            <div>{{item.amount}}</div>
                        </div>

                         <div class='flex-row'>   
                            <div style='color:red'>{{item.stateValue}}</div>
                            <div>{{item.operationTime}}</div>
                        </div>
                        
                    </a-list-item>

                </template>

            </a-list>
          
        </a-modal>
       
        
    </div>
</template>

<script>
  import shopApi from '@axios/shop'
  import moment from 'moment';
  import { reactive, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import orderApi from '@axios/order'
  import orderState  from '@assets/static';
  import { message } from 'ant-design-vue';
  export default {
    name: 'orderDetail',
    components: {
    },
    setup(){
        let loading = ref(false);
        const router = useRouter()
        let list = ref([]);
        const route = useRoute();
        const code = route.query.code;
        let detail = ref({});
        let modalVisible = ref(false);
        let chooseSeats = ref([]);

        let operationLogList = ref([])
        const getDetail = (code) => {
            orderApi.purchase(code).then((res)=>{
                detail.value = res;
                chooseSeats.value.push(res);
                operationLogList.value = res.operationLogList;
            
            })
        }   
        getDetail(code);    

        let associateddata = ref([]);

        let associateValue = {
            10 : '普通订单',
            20 : '改签订单',
            30 : '退票订单'
        }

        const associated = () =>{
            let params = {
               orderCode : detail.value.orderCode
            }
            orderApi.associated(params).then((res) => {

                if(res.length){
                    modalVisible.value = true;
                    associateddata.value = res;
                }else{
                    message.error('未查询到关联单')
                }
            })
        }

        const toRefoundDetail = (item) =>{
            let name = 'orderDetail'
            if(item.orderType == 30){
                name = 'refundDetailIndex'
            }
            const newweb = router.resolve({name: name, query: {
                code : item.orderCode
            }})
            window.open(newweb.href,'_blank')
        }

        const backPage = () => {
            router.back();
        }

        const changeState = (detail) => {
            if(detail.returnState == 10){
                if(detail.changeState == 10){
                    return detail.orderStateValue
                }else{
                    return detail.changeStateValue
                }
            }else{
                return detail.returnStateValue
            }
        }

        return {
            changeState,
            associateValue,
            operationLogList,
            backPage,
            toRefoundDetail,
            associateddata,
            associated,
            modalVisible,
            orderState,
            activeKey : ['1'],
            loading,
            detail,
            chooseSeats,
            list,
            columns : [
                {
                    title: '乘客',
                    dataIndex: 'passengerName',
                    width: 100,
                    align : 'center',
                
                },
                {
                    title: '票号',
                    dataIndex: 'ticketNo',
                    width: 100,
                    align : 'center',
                
                },
                {
                    title: '车票类型',
                    dataIndex: 'mobile',
                    width: 100,
                    align : 'center',
                    slots: { customRender: 'type' },
                
                },
                {
                    title: '座位',
                    dataIndex: 'lastCoach',
                    width: 100,
                    align : 'center',
                    slots: { customRender: 'lastCoach' },
                },
                {
                    title: '检票口',
                    dataIndex: 'ticketCheck',
                    width: 100,
                    align : 'center',
                },
                {
                    title: '手机号',
                    dataIndex: 'mobile',
                    width: 150,
                    align : 'center',
                },
                {
                    title: '证件类型',
                    dataIndex: 'cardTypeValue',
                    width: 100,
                    align : 'center',
                },
                {
                    title: '证件号',
                    dataIndex: 'cardNo',
                    width: 200,
                    align : 'center',
                },
                
            ],
            choosesSeatColumn:[
              {
                title: "指定座位",
                dataIndex: "chooseSeats",
                width: 100,
                align: "center",
                slots: {customRender: "chooseSeats"}
              },
              {
                title: "接受无座",
                dataIndex: "acceptNoSeat",
                width: 100,
                align: "center",
                slots: {customRender: "acceptNoSeat"}
              },
              {
                title: "接受其他座位",
                dataIndex: "chooseOther",
                width: 100,
                align: "center",
                slots: {customRender: "chooseOther"}
              },{
                title: "接受部分出票",
                dataIndex: "acceptNoTotal",
                width: 100,
                align: "center",
                slots: {customRender: "acceptNoTotal"}
              }
            ]
        }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .a_list /deep/  .ant-list-item{
        display: block!important;
        background: #eee!important;
        padding: 10px 10px;
        border-radius:3px ;
        margin-bottom: 20px;
    }
    .log_content{
        margin-top:20px;
   
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .log_content /deep/ .ant-collapse-content-box{
        padding-bottom: 0!important;
    }

    .log_content /deep/ .ant-timeline-item-content{
        min-height:auto!important ;
    }
    .log_content /deep/ .ant-card-body{
        padding-top:30px;
        padding-bottom:10px;
    }
    .clb{
        color:#000;
    }
    .title_row{
        line-height: 40px;
        font-size: 20px;
    }
    .ticket{
        display: flex;
        justify-content: flex-start;
        div{
            margin-right: 30px;
           
            font-size: 20px;
            color:#000;
            font-weight: bold;
        }
        .line_content{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            line-height: 20px!important;
            text-align: center;
            font-size: 16px;
            position: relative;
            top:-10px;
        
            .line{
                margin-top: 5px;
                width: 150px;
                height: 1px;
                background: rgba(0, 0, 0, 0.65);
            }
        }
    }
    .ticket_time{
        padding-right: 10px;
        line-height: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: right;
        flex-direction: column;
    }
    .time_div{
      
        font-weight: normal;
    }
    .flex-row{
        width: 100%;
        display:flex;
        justify-content: space-between!important;
    }
  
</style>
